import React from "react";
import MembersPanel from "@/pages/admin/MembersPanel";
import LegacyHost from "@/pages/admin/os/LegacyHost";

export default function MembersPage() {
  return (
    <LegacyHost
      title="Members"
      migratedFrom="Editorial desk · Members"
      testid="os-operations-members"
    >
      <MembersPanel />
    </LegacyHost>
  );
}
